import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import Button from "../../components/button";
import { PhoneInput } from "../../wrappers/phoneInput";
import Styles from "./styles.module.scss";
import * as Yup from "yup";
import FromHead from "../../components/headings/FromHead";
import { FormInput } from "../../wrappers/formInput";
import { DropDownInput } from "../../wrappers/selectInput";
import * as CONSTANTS from "../../utils/CONSTANTS";
import FreeField from "../../components/field/freeField";
import TagLabel from "../../components/TagLabel";
import Combodropdown from "../../components/autocomplete";
import { workexperience } from "../../utils/EllowUtils";
import { Error } from "@progress/kendo-react-labels";
import classnames from "classnames";
import RadioGroup from "../../components/radioGroup";


export type PersonalDetailsFormFields = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  workExp?: any;
  designation?: string;
  jobRole?: any;
  noticePeriod?: string;
  billingType?: string;
  currencyType?: string;
  expectedPay?: string;
  workType?: any;
};

interface Props {
  defaultValues: any;
  ClickHandler?: any;
  disable?: boolean;
  profileSubmitted?: boolean;
  jobRolesList: any;
}

const validationSchema = Yup.object({
  firstName: Yup.string().required("Field is required"),
  lastName: Yup.string().required("Field is required"),
  email: Yup.string()
    .required("Field is required")
    .email("Please provide a valid email address")
    .nullable(true),
  phoneNumber: Yup.string()
    .required("Field is required")
    .min(5, "Invalid Phone Number")
    .max(15, "Invalid Phone Number"),
  expectedPay: Yup.string().required("Field is required"),
  billingType: Yup.string().required("Field is required"),
  currencyType: Yup.string().required("Field is required"),
  designation: Yup.string().required("Field is required"),
  noticePeriod: Yup.string().required('Field is required')
});

const PersonalDetails: React.FC<Props> = ({ ClickHandler, defaultValues , disable, profileSubmitted, jobRolesList }) => {
  const formOptions = {
    resolver: yupResolver(validationSchema),
    // defaultValues: useMemo(() => {
    //   return defaultValues;
    // }, [defaultValues]),
  };

  const { register, handleSubmit, control, reset, setValue, watch, formState } =
    useForm<PersonalDetailsFormFields>(formOptions);

  const [workType, setWorkType] = useState<any>()
  const [designation, setDesignation] = useState<any>();
  const [workExp, setWorkExp] = useState<any>({ years: "", months: "" });
  const [type, setType] = useState<string>('')
  const [engineeringOthers, setEngineeringOthers] = useState<boolean>(false);
  const [addedEngineering, setAddedEngineering] = useState<
    { name: string; id: number; other: boolean }[]
  >([]);
  const getAddedEngineering = () => [
    ...CONSTANTS.Engineering,
    ...addedEngineering.filter((item) => item.other),
  ];
  const getDefaultJobRoles = (item: { name: string; id: number }) =>
    addedEngineering
      ? !!addedEngineering.filter((id) => id.id === item.id).length
      : false;
  const [errors, setErros] = useState<{
    workExp?: string;
    engieering?: string;
    designation?: string;
    workType?: any;
  }>({
    workExp: "",
    engieering: "",
    designation: "",
    workType:""
  });


  useEffect(() => {
    if (defaultValues) {
      reset(defaultValues)
      if (defaultValues.jobRoles && defaultValues.jobRoles.length > 0)
      {
        const jobRoles = defaultValues.jobRoles.map((item: any) => {
            return {
              name: item.name,
              id: item.id,
              other:
                CONSTANTS.Engineering.filter(
                  (engineering) => engineering.id === item.id
                ).length === 0,
            };
          });
        setAddedEngineering(jobRoles);
      }
      if (defaultValues.designation) {
        setDesignation(defaultValues.designation ? defaultValues.designation : " ");
      }
      if (defaultValues.workExp) {
           setWorkExp(
      defaultValues.workExp
        ? {
            years: workexperience(defaultValues.workExp, 0),
            months: workexperience(defaultValues.workExp, 1),
          }
        : { years: "", months: "" }
    );
      }
      if (defaultValues.workType) {
        setValue('workType', parseInt(defaultValues.workType))
        setWorkType(parseInt(defaultValues.workType))
      }
  }
    // setWorkExp(
    //   defaultValues.workExp
    //     ? {
    //         years: workexperience(defaultValues.workExp, 0),
    //         months: workexperience(defaultValues.workExp, 1),
    //       }
    //     : { years: "", months: "" }
    // );
    // setDesignation(defaultValues.designation ? defaultValues.designation : " ");
  }, [defaultValues]);

  const engineeringChange = (
    e: any,
    engineering: { name: string; id: number }
  ) => {
    delete errors.engieering;
    setErros({ ...errors });

    let updatedEngineering: { name: string; id: number; other: boolean } = {
      ...engineering,
      other: e === "addValue",
    };

    if (engineering !== null) {
      if (e.value || e === "addValue") {
        addedEngineering.push(updatedEngineering);
        delete errors.engieering;
        setErros({ ...errors });
        if (engineering.name === "Others") {
          setEngineeringOthers(true);
        }
      } else {
        const index = addedEngineering.findIndex(
          (item) => item.id === engineering.id
        );
        if (index > -1) {
          addedEngineering.splice(index, 1);
        }
        if (engineering.name === "Others") {
          setEngineeringOthers(false);
        }
      }
      setAddedEngineering([...addedEngineering]);
      setErros({ ...errors });
    }
  };

  const designationChange = (e: any) => {
    delete errors.designation;
    setDesignation(e.target.value);
  };

  const experienceChange = (e: any, fieldName: string) => {
    delete errors.workExp;
    workExp[fieldName] = e.target.value ? Math.abs(e.target.value) : "";
    setWorkExp({ ...workExp });
    setErros({ ...errors });
  };

  const onSubmitForm = (data: any) => {
    
    let isErrored = false;
    let jobRoles: any[] = [];
    let rolesWithoutOthers = addedEngineering.filter(
      (item) => item.name !== "Others"
    );

    if (!workExp.years && workExp.years !== 0) {
      errors.workExp = "Please add years of experience";
      isErrored = true;
    }
    if(workType === undefined){   
      errors.workType = "Please select work type"
      isErrored = true;
    }
    if (!rolesWithoutOthers || rolesWithoutOthers.length === 0) {
      errors.engieering = "Select atleast one role ";
      isErrored = true;
    } else if (rolesWithoutOthers.length > 3) {
      errors.engieering = "Maximum three roles are allowed";
      isErrored = true;
    }

    jobRoles = rolesWithoutOthers.map((item, i) => {
      return {
        name: item.name,
        id: item.id,
      }
    })

    
    let value = {
      designation: data.designation,
      email: data.email,
      firstName: data.firstName,
      jobRoles: jobRoles,
      lastName: data.lastName,
      phoneNumber: data.phoneNumber,
      workExperience: parseFloat(`${workExp.years}.${workExp.months}`),
      preference: {
        salary: { billingType: data.billingType,
          currencyType: data.currencyType,
          expectedPay: data.expectedPay}
      },
      availability: {
        availabilityId: 3,
        date:  0,
        weeks: data.noticePeriod,
        lastUpdateDate: new Date().getTime()
      },

      workType: workType,
      type: 'submit'
    };
    
      if (!isErrored) {
     ClickHandler(value);         
      }
  };

  const saveForm = (data: any) => {
    let jobRoles: any[] = [];
    let rolesWithoutOthers = addedEngineering.filter(
      (item) => item.name !== "Others"
    );
    jobRoles = rolesWithoutOthers.map((item, i) => {
      return {
        name: item.name,
        id: item.id,
      };
    });
    let value = {
      designation: data.designation,
      email: data.email,
      firstName: data.firstName,
      jobRoles: jobRoles,
      lastName: data.lastName,
      phoneNumber: data.phoneNumber,
      workExperience: workExp && parseFloat(`${workExp.years}.${workExp.months}`),
      preference: {
        salary: { billingType: data.billingType,
          currencyType: data.currencyType,
          expectedPay: data.expectedPay}
      },
      availability: {
        availabilityId: 3,
        date:  0,
        weeks: data.noticePeriod,
        lastUpdateDate: new Date().getTime()
      },

      workType: workType,
      type: 'save'
    };
    ClickHandler(value)
  }

  const handleChange = (e: any) => {
    delete errors.workType
    setValue('workType', e.value)
    setWorkType(e.value)
    
  }
  return (
    <form>
      <section className={classnames(Styles.personalDetails, Styles.tabPadding)}>
        
        <FromHead>Provide your personal details</FromHead>
        <div className="half-form-wrap">
          <div className="form-group">
            <FormInput<PersonalDetailsFormFields>
              id="firstName"
              type="text"
              name="firstName"
              label="First Name*"
              placeholder="First Name"
              register={register}
              errors={formState.errors}
            />
          </div>
          <div className="form-group">
            <FormInput<PersonalDetailsFormFields>
              id="lastName"
              type="text"
              name="lastName"
              label="Last Name*"
              placeholder="Last Name"
              register={register}
              errors={formState.errors}
            />
          </div>
        </div>


        <FromHead>Provide your contact details</FromHead>
        <div className="half-form-wrap">
          <div className="form-group">
            <FormInput<PersonalDetailsFormFields>
              id="email"
              type="text"
              name="email"
              label="Email*"
              placeholder="Email"
              register={register}
              errors={formState.errors}
              // onBlur={handleSubmit(onSubmitForm)}
            />
          </div>
          <div className="form-group">
          <PhoneInput<PersonalDetailsFormFields>
              id="phoneNumber"
              type="text"
              name="phoneNumber"
              label="Phone Number*"
              size="medium"
              register={register}
              errors={formState.errors}
              control={control}
            />
          </div>
        </div>
        <FromHead>
          How many years of professional experience do you have ?*
        </FromHead>
        <div className="form-group mb-40">
          <p className={Styles.experienceWrap}>
            I have
            <FreeField
              id="years"
              name="years"
              placeholder=""
              type="number"
              autoComplete="off"
              size="small"
              value={workExp.years}
              onChange={(e: any) => experienceChange(e, "years")}
            />
            years and
            <FreeField
              id="months"
              placeholder=""
              autoComplete="off"
              type="number"
              size="small"
              // min="0"
              value={workExp.months}
              onChange={(e: any) => experienceChange(e, "months")}
            />
            months of experience in software development
          </p>
        </div>
        <p>
          <Error> {errors.workExp}</Error>{" "}
        </p>
        <FromHead>What engineering role identifies you better?*</FromHead>
        <div className="form-group mb-40">
          {getAddedEngineering().map((item, key) => (
            <TagLabel
              label={item.name}
              key={key}
              value={item.id}
              checked={getDefaultJobRoles(item)}
              handleChange={(e: any) => engineeringChange(e, item)}
            />
          ))}
          {engineeringOthers && (
            <div className={Styles.tagDropdown}>
              <Combodropdown
                placeholder="Please search your role"
                data={jobRolesList}
                name="name"
                id="id"
                handleChange={(value: {
                  name: string;
                  id: number;
                  other: boolean;
                }) => engineeringChange("addValue", value)}
              />
            </div>
          )}
              </div>
              <p><Error>{errors.engieering}</Error></p>
        {/* <FromHead>Designation</FromHead> */}
        <div className="half-form-wrap">
          <div className="form-group">
            <FormInput<PersonalDetailsFormFields>
              id="designation"
              type="text"
              name="designation"
              placeholder="Enter the designation"
              register={register}
              label={'Designation*'}
              errors={formState.errors}
            />
          </div>
          <div className="form-group">
            <FormInput<PersonalDetailsFormFields>
              id="noticePeriod"
              type="text"
              name="noticePeriod"
              placeholder="Notice Period"
              register={register}
              label={'Notice Period (Weeks)'}
              errors={formState.errors}
            />
          </div>
        </div>
        <section className={Styles.preferencesWrap}>
          <FromHead>Preferences</FromHead>
          <div className="pay-exp-wrap">
            <div className="form-group ">
              <label className="lablel">Candidate's expected pay*</label>
              <FormInput<PersonalDetailsFormFields>
                id="expectedPay"
                name="expectedPay"
                type="number"
                //value={payValue}
                placeholder="Enter Amount"
                register={register}
                errors={formState.errors}
                //   onchange={(e: any) => handleChange(e, "expectedPay")}
              />
            </div>
            <div className={classnames(Styles.currencyFiled, "label-position")}>
              <div className="form-group">
                <label className="lablel">INR/USD*</label>
                <DropDownInput<PersonalDetailsFormFields>
                  data={CONSTANTS.currencyTypeList}
                  name="currencyType"
                  label=""
                  control={control}
                  register={register}
                  errors={formState.errors}
                  />
              </div>
            </div>
            <div className="form-group form-per label-position">
              <label className="lablel">per</label>
              <div className="form-group">
                <label className="lablel">Hour/Day/Month*</label>
                <DropDownInput<PersonalDetailsFormFields>
                  data={CONSTANTS.timeBasisList}
                  name="billingType"
                  label=""
                  control={control}
                  register={register}
                  errors={formState.errors}
                  />
              </div>
            </div>
          </div>
        </section>
        <section>
              <FromHead>Candidate’s Preferred work </FromHead>
              <div className="form-group mb-40">
            <RadioGroup
          data={[ { label: "Contract", value: 1 },{ label: "Permanent full time employee", value: 2 }, { label: 'Open for both', value: 3}]}
          layout="horizontal"
          handleChange={(e: any) => handleChange(e)}
          checked={workType}
        />
        <p><Error>{errors?.workType}</Error></p>
      </div>
              </section>
        <div className={Styles.alignRight}>
          <Button disabled={disable} onClick={handleSubmit(saveForm)} variant="secondary">
            Save to draft
          </Button>
          <Button disabled={disable} onClick={handleSubmit(onSubmitForm)} variant="primary">
           Submit Profile
          </Button>
        </div>
      </section>
    </form>
  );
};
export default PersonalDetails;
